import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  Observable,
  defer,
  of
} from 'rxjs';
import {
  selectConfigState,
  isAuthEnabled
} from './config.selectors';
import {
  tap,
  switchMap,
  distinctUntilChanged,
  filter,
  first,
  share
} from 'rxjs/operators';
import { LifeCycleService } from '../life-cycle/life-cycle.service';
import { NGXLogger } from 'ngx-logger';
import { ConfigState } from '@digitaix/types';
import { SetConfig } from './config.actions';
import { ConfigLoaderService } from './config-loader.service';

@Injectable({ providedIn: 'root' })
export class ConfigService<C extends ConfigState = ConfigState> {

  public readonly config$: Observable<C> = this.store$.select(selectConfigState);
  public readonly config: C;

  // TODO : move to auth service
  public isAuthEnabled$: Observable<boolean> = this.store$.select(isAuthEnabled).pipe(distinctUntilChanged());

  // TODO : move to auth service
  public authIsEnabled$ = this.isAuthEnabled$.pipe(
    filter(authEnabled => authEnabled === true),
    first(),
    tap(() => this.logger.debug('[ConfigService::authIsEnabled$]')),
    share(),
  );

  constructor(
    public readonly store$: Store<any>,
    public readonly lifeCycle: LifeCycleService,
    private readonly logger: NGXLogger,
    private readonly configLoader: ConfigLoaderService<C>,
  ) {
    this.config = configLoader.config;
    console.log('use config', this.config);
    this.lifeCycle.whenAppInit(of(new SetConfig(configLoader.config))).subscribe(this.store$);
    // this.config$.pipe(
    //   filter(Boolean),
    //   tap(config => this.config = config),
    // ).subscribe();
  }

  public get<T = any | null>(path: string, defaultValue: T = null): T {
    const fragments = path.split('.');
    let currentSlice = this.config;
    for (const fragment of fragments) {
      if (currentSlice && currentSlice.hasOwnProperty(fragment)) {
        currentSlice = currentSlice[fragment];
      } else {
        return defaultValue;
      }
    }

    return currentSlice as any;
  }

  /**
   * @deprecated the config is loaded with APP_INITIALIZER and therefor
   * any time present
   * @param observable
   */
  public whenConfigLoaded<T>(observable: Observable<T> | (() => Observable<T>)): Observable<T> {
    return this.lifeCycle.whenConfigLoaded(observable);
  }

  // TODO : move to auth service
  public whenAuthEnabled<T>(observable: Observable<T> | (() => Observable<T>)): Observable<T> {
    if (typeof observable === 'function') {
      observable = defer(observable);
    }

    return this.lifeCycle.whenStable(this.authIsEnabled$.pipe(
      switchMap(() => observable)
    ));
  }

}
